import(/* webpackMode: "eager" */ "/app/app/(main)/page.tsx");
